let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("iAaum"), load("6vzdH"), load("eabDm"), load("4yUSc")]).then(() => parcelRequire('9xi4O'));